import axios from 'axios'
import config from './config/global.config'
import log from '@/utility/Logger'

var vueStore = null

const api = axios.create({
  baseURL: config.appUrl,
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// Capture unauthenticated error and redirect to root
api.interceptors.response.use(undefined, err => {
  if ((typeof err.response) !== 'undefined' && err.response.status === 401) {
    if (vueStore) {
      vueStore.dispatch('auth/logout')
    }

    window.location.href = `${config.appUrl}/index.php?returnUrl=${window.location.href}`
  }

  return Promise.reject(err)
})

// Set header to allow us to authenticate with the api
const setAuthToken = token => {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

api.install = function (Vue, { store }) {
  Vue.prototype.$http = api

  if (store) {
    vueStore = store
    store.watch(state => state.auth.token, setAuthToken, {
      immediate: true
    })
  }
}

api.makeRequest = function (url) {
  url = config.apiUrl(url)

  log.log('makeRequest', url)

  if (vueStore) {
    let self = this

    return vueStore.dispatch('auth/userData').then(userData => {
      return self.get(url)
    })
  }

  return this.get(url)
}

api.authenticated = function () {
  return vueStore.dispatch('auth/userData')
}

api.postRequest = function (url, data) {
  url = config.apiUrl(url)

  log.log('postRequest', url)

  return this.post(url, data)
}

api.deleteRequest = function (url, data) {
  url = config.apiUrl(url)

  log.log('deleteRequest', url)

  return this.delete(url, data)
}

api.putRequest = function (url, data) {
  url = config.apiUrl(url)
  return this.put(url, data)
}

api.postLegacyRequest = function (url, data) {
  url = config.applicationUrl(url)

  log.log('postLegacyRequest', url)

  return this.post(url, data)
}

api.deleteLegacyRequest = function (url, data) {
  url = config.applicationUrl(url)

  log.log('deleteLegacyRequest', url)

  return this.delete(url, data)
}

api.makeLegacyRequest = function (url) {
  url = config.applicationUrl(url);

  log.log('makeLegacyRequest', url)

  return this.get(url)
}

export default api
